import { render, staticRenderFns } from "./CrimeList.vue?vue&type=template&id=7e44243a&"
import script from "./CrimeList.vue?vue&type=script&lang=js&"
export * from "./CrimeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports